import AOS from 'simple-aos'

export function aos() {
	AOS.init({
		disable: 'mobile',
		duration: 800,
		offset: 100,
		delay: 120,
		once: true
	})
}